export default __webpack_public_path__ + "static/media/return.00bc60e5.svg";